import { render, staticRenderFns } from "./AIindex.vue?vue&type=template&id=b4d091d0&scoped=true&"
import script from "./AIindex.vue?vue&type=script&lang=js&"
export * from "./AIindex.vue?vue&type=script&lang=js&"
import style0 from "./AIindex.vue?vue&type=style&index=0&id=b4d091d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d091d0",
  null
  
)

export default component.exports